/* src/app/_shared/components/toolbar/toolbar.component.scss */
.flow-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row nowrap;
  position: relative;
  width: 100%;
  min-height: 52px;
  padding: var(--space-top) calc(var(--space-right) / 2) var(--space-bottom) calc(var(--space-left) / 2);
  background-color: #FFFFFF;
}
.flow-toolbar .start-buttons {
  display: flex;
  flex-flow: row nowrap;
  justify-self: flex-start;
  min-height: 1px;
  white-space: nowrap;
}
.flow-toolbar .start-buttons > * {
  margin-right: 10px;
}
.flow-toolbar .big-title-container {
  width: 100%;
}
.flow-toolbar .title {
  padding: 0 10px;
  font-weight: bold;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: center;
  white-space: nowrap;
  overflow: hidden;
  opacity: 0;
  transition: all 0.2s;
}
.flow-toolbar .title.visible {
  opacity: 1;
}
.flow-toolbar .end-buttons {
  display: flex;
  flex-flow: row nowrap;
  justify-self: flex-end;
  justify-content: flex-end;
  min-height: 1px;
  text-align: right;
  white-space: nowrap;
}
.flow-toolbar .end-buttons > * {
  margin-left: 10px;
}
/*# sourceMappingURL=toolbar.component.css.map */
